import React from 'react';
import ModalWrapper from './ModalWrapper';

export default function CustomerDetailModal({ open, customer, items, onClose }) {
  if (!open || !customer) return null;

  // Filter items for this customer
  const customerItems = items.filter(i => i.clientId === customer.id);
  // Group by description
  const descMap = {};
  customerItems.forEach(i => {
    if (!descMap[i.mainCategory]) descMap[i.mainCategory] = [];
    descMap[i.mainCategory].push(i);
  });

  // Helper for number formatting: 10 000 instead of 10000
  function formatNumber(n) {
    if (n === null || n === undefined || isNaN(Number(n))) return n;
    return Number(n).toLocaleString('en-US').replace(/,/g, ' ');
  }

  return (
    <ModalWrapper open={open} onClose={onClose} zIndex={40} minWidth={700} maxWidth={900}>
      <div style={{padding: 8}}>
        <h2 style={{marginTop:0, color:'#1976d2'}}>{customer.name} - Details</h2>
        <div style={{marginBottom: 18, color:'#555'}}>
          <b>Contact:</b> {customer.contactInfo || <span style={{color:'#aaa'}}>N/A</span>}
        </div>
        <h4 style={{margin:'14px 0 6px 0'}}>Descriptions & Items</h4>
        {Object.keys(descMap).length === 0 && (
          <div style={{color:'#888',margin:'12px 0'}}>No items found for this customer.</div>
        )}
        {Object.entries(descMap).map(([desc, items]) => (
          <div key={desc} style={{marginBottom:10}}>
            <div style={{fontWeight:600, color:'#1976d2', marginBottom:2}}>{desc}</div>
            <table style={{width:'100%',marginBottom:6,background:'#f8fafc',borderRadius:6}}>
              <thead>
                <tr style={{fontSize:13,color:'#333'}}>
                  <th style={{textAlign:'left',padding:'0 32px'}}>Product Code</th>
                  <th style={{textAlign:'left',padding:'0 32px'}}>Variant</th>
                  <th style={{textAlign:'left',padding:'0 32px'}}>Current Qty</th>
                  <th style={{textAlign:'left',padding:'0 32px'}}>Cost (R/1000)</th>
                </tr>
              </thead>
              <tbody>
                {items.map(i => (
                  <tr key={i.id}>
                    <td style={{textAlign:'left',padding:'0 32px'}}>{i.productCode}</td>
                    <td style={{padding:'0 32px'}}>{i.variantDesc}</td>
                    <td style={{textAlign:'left',padding:'0 32px'}}>{formatNumber(i.currentQty)}</td>
                    <td style={{padding:'0 32px'}}>{formatNumber(i.cost)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
        <div style={{display:'flex',justifyContent:'center',marginTop:18}}>
          <button onClick={onClose} style={{background:'#fff',color:'#1976d2',fontWeight:600,padding:'10px 32px',border:'1.5px solid #1976d2',borderRadius:8,fontSize:16}}>Close</button>
        </div>
      </div>
    </ModalWrapper>
  );
}
